import type { Composer } from '@brent/shared/types'
import apiClient from './client'

export interface ComposerListResponse {
  composers: Composer[]
}

export interface ComposerWork {
  id: number
  work_id: number
  title_canonical: string
  title_short: string | null
  wikidata_id: string | null
  wikidata_label: string | null
  confidence: number | null
  quality_score: string
  programme_count: number
}

export interface ComposerConcertItem {
  id: number
  concert_id: number
  position: number
  composer_id: number
  composer_name: string | null
  composer_qid: string | null
  work_id: number | null
  work_title: string | null
  work_qid: string | null
  work_text: string | null
  composer_text: string | null
  arrangement_note: string | null
  notes: string | null
  quality_score: string
  date_text: string | null
  date_iso: string | null
  year: number | null
  venue_name: string | null
}

export interface ComposerDetailResponse {
  composer: Composer
  works: ComposerWork[]
  concerts: ComposerConcertItem[]
}

export interface UpdateComposerInput {
  quality_score?: string
  wikidata_id?: string
  birth_year?: number | null
  death_year?: number | null
}

export interface UpdateComposerResponse {
  ok: boolean
  enriched?: {
    label: string
    description: string
    birth_year: number
    death_year: number
  }
  cleared?: boolean
  error?: string
}

export async function fetchComposers(): Promise<Composer[]> {
  const response = await apiClient.get<ComposerListResponse>('/composers')
  return response.composers
}

export async function fetchComposer(id: number): Promise<ComposerDetailResponse> {
  return apiClient.get<ComposerDetailResponse>(`/composers/${id}`)
}

export async function updateComposer(
  id: number,
  input: UpdateComposerInput,
): Promise<UpdateComposerResponse> {
  return apiClient.put<UpdateComposerResponse>(`/composers/${id}`, input)
}
